export default function createDeviceMetrics() {
    const deviceMetrics = {
        device_resolution: `${window.innerWidth}x${window.innerHeight}`,
        device_memory: window.navigator.deviceMemory,
        device_concurrency: window.navigator.hardwareConcurrency,
    };
    return deviceMetrics;
}
